import { formatNumber } from '../qrs/states';
import type { Lot } from '../qrs/types';

export const MAX_LOT = 5000;

export function parseQuantity(raw: string): number | null {
  const n = Number(raw.replace(/\./g, '').trim());
  return Number.isInteger(n) && n >= 1 && n <= MAX_LOT ? n : null;
}

export function parseCodes(raw: string): string[] {
  return Array.from(new Set(raw.toUpperCase().split(/[\s,;]+/).map((c) => c.trim()).filter(Boolean)));
}

export const DISTANCES = [
  { cm: 30, label: '30 cm · mesa (QR ≥ 3 cm)' },
  { cm: 100, label: '1 m · mostrador (QR ≥ 10 cm)' },
  { cm: 300, label: '3 m · pendón (QR ≥ 30 cm)' },
];

export function lotDistribution(lot: Lot): string {
  const c = lot.counts ?? {};
  const parts: string[] = [];
  if (c.generado) parts.push(`${formatNumber(c.generado)} generados`);
  if (c.impreso) parts.push(`${formatNumber(c.impreso)} sin asignar`);
  if (c.en_custodia) parts.push(`${formatNumber(c.en_custodia)} custodia`);
  if (c.activado) parts.push(`${formatNumber(c.activado)} activados`);
  if (c.suspendido) parts.push(`${formatNumber(c.suspendido)} suspendidos`);
  if (c.dado_de_baja) parts.push(`${formatNumber(c.dado_de_baja)} baja`);
  return parts.join(' · ') || '—';
}

export function lotStatus(lot: Lot): { label: string; tone: 'neutral' | 'premium' } {
  return lot.status === 'impreso' ? { label: 'Impreso', tone: 'neutral' } : { label: 'Generado', tone: 'premium' };
}
